import React, { useCallback, useEffect } from 'react';
import { PROGRESS_STEP, PROGRESS_INTERVAL_MS, END_PROGRESS_PERCENTAGE } from '../../constants.js';
import ProgressBar from './ProgressBar.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var ProgressBarContainer = function (_a) {
    var _b = _a.endPercentage, endPercentage = _b === void 0 ? END_PROGRESS_PERCENTAGE : _b, progressConfig = _a.progressConfig, setProgress = _a.setProgress, className = _a.className;
    var frame = useCallback(function () {
        setProgress(function (_a) {
            var progress = _a.progress, intervalId = _a.intervalId;
            if (progress >= endPercentage) {
                clearInterval(intervalId);
                return {
                    intervalId: intervalId,
                    progress: progress
                };
            }
            return {
                intervalId: intervalId,
                progress: progress + PROGRESS_STEP
            };
        });
    }, [endPercentage, setProgress]);
    useEffect(function () {
        var id = setInterval(frame, PROGRESS_INTERVAL_MS);
        setProgress(function (prevProgressConfig) { return ({
            intervalId: id,
            progress: prevProgressConfig.progress
        }); });
        return function () {
            clearInterval(id);
        };
    }, [frame, setProgress]);
    return React.createElement(ProgressBar, { className: className, progress: progressConfig.progress });
};

export { ProgressBarContainer as default };
//# sourceMappingURL=ProgressBarContainer.js.map
